import {inject, Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';

import {catchError, filter, map, switchMap, take, withLatestFrom} from 'rxjs/operators';
import {AppState} from '../core.state';
import {of} from 'rxjs';
import {AuthSelectors} from '../stores/auth/selectors';
import {SelectUrlStateForError} from '../router/router.state';
import {environment} from '../../../environments/environment';
import {Capacitor} from '@capacitor/core';
import {ApiWebService} from '../../shared/@types';

@Injectable({
  providedIn: 'root'
})
export class ErrorReportService extends ApiWebService {

  private store$ = inject(Store<AppState>);

  constructor() {
    super('app-errors');
  }

  sendErrorToApi$(error) {
    return this.store$.select(AuthSelectors.selectIsAuthenticated).pipe(
      take(1),
      filter((isAuth) => isAuth), // Invio l'errore solo se autenticato (forse da eliminare)
      withLatestFrom(
        this.store$.pipe(select(AuthSelectors.selectAuthUserData)),
        this.store$.pipe(select(SelectUrlStateForError)),
      ),
      switchMap(([, authUserData, urlState]) => this.post$({
        message: error?.message ?? 'Messaggio di errore non identificato',
        stack: JSON.stringify(error?.stack ?? error?.originalStack ?? null),
        userdata: {...authUserData, userAgent: error.userAgent},
        uri: urlState?.url,
        queryParams: {params: urlState?.params, queryParams: urlState?.queryParams},
        platform: Capacitor.getPlatform(),
        appVersion: environment.appVersion
      }).pipe(
        map((res) => res),
        catchError((error2) => {
          if (!environment.production) {
            console.log('Errore da inviare', error);
            console.log('Nuovo Errore', error2);
          }
          return of([]);
        })
      ))
    );
  }

  /**
   * Metodo per test del sistema di error reporting
   */
  testErrorReporting() {
    if (!environment.production) {
      try {
        // Simula un errore per test
        throw new Error('Test error reporting system');
      } catch (e) {
        this.sendErrorToApi$(e).subscribe();
      }
    }
  }


}
